import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token");
  return { Authorization: `Bearer ${token}` };
};

export const listExpenseUserNotes = async () => {
  const res = await axios.get(`${API_URL}/api/expenses-user/notes`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getExpenseUserNote = async (id) => {
  const res = await axios.get(`${API_URL}/api/expenses-user/notes/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createExpenseUserNote = async (body) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/notes`,
    {
      title: body.title,
      description: body.description,
    },
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res.data;
};

export const deleteExpenseUserNote = async (id) => {
  await axios.delete(`${API_URL}/api/expenses-user/notes/${id}`, {
    headers: authHeaders(),
  });
};

export const openExpenseUserNotePdf = async (id) => {
  const res = await axios.get(
    `${API_URL}/api/expenses-user/notes/${id}/pdf`,
    {
      headers: authHeaders(),
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 120_000);
};

export const createExpenseUserAdvance = async (noteId, body) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/notes/${noteId}/advances`,
    body,
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res.data;
};

export const patchExpenseUserAdvance = async (noteId, advanceId, body) => {
  const res = await axios.patch(
    `${API_URL}/api/expenses-user/notes/${noteId}/advances/${advanceId}`,
    body,
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res.data;
};

export const deleteExpenseUserAdvance = async (noteId, advanceId) => {
  const res = await axios.delete(
    `${API_URL}/api/expenses-user/notes/${noteId}/advances/${advanceId}`,
    { headers: authHeaders() }
  );
  return res.data;
};

export const createExpenseUserPayment = async (noteId, body) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/notes/${noteId}/payments`,
    body,
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res.data;
};

export const deleteExpenseUserPayment = async (noteId, paymentId) => {
  const res = await axios.delete(
    `${API_URL}/api/expenses-user/notes/${noteId}/payments/${paymentId}`,
    { headers: authHeaders() }
  );
  return res.data;
};
